import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Link } from "Navigation/Link";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { Box, Button, LinearProgress, Stack, Typography } from "@mui/material";
import { useEffect } from "react";

const RESOURCES = Resources.Nfc;

type Props = {
  redirectUrl?: string | null;
};

export const NfcRedirect = ({ redirectUrl }: Props) => {
  const { t } = useResource();

  useEffect(() => {
    if (redirectUrl) {
      window.location.replace(redirectUrl);
    }
  }, [redirectUrl]);

  if (!redirectUrl) {
    return (
      <PrimaryPaper>
        <Typography>{t(RESOURCES.RedirectNotConfigured)}</Typography>
      </PrimaryPaper>
    );
  }

  return (
    <PrimaryPaper>
      <Typography textAlign="center" mb={4}>
        {t(RESOURCES.Redirecting)}
      </Typography>
      <Box display="flex" justifyContent="center" mb={6}>
        <Box width="40%">
          <LinearProgress color="info" />
        </Box>
      </Box>
      <Typography textAlign="center" mb={1}>
        {t(RESOURCES.RedirectFallbackHint)}
      </Typography>
      <Stack alignItems="center" gap={1}>
        <Button href={redirectUrl}>{t(RESOURCES.RedirectManually)}</Button>
        <Button component={Link} size="small" to={appUrl("homepage")}>
          {t(Resources.Common.BackToMoone)}
        </Button>
      </Stack>
    </PrimaryPaper>
  );
};
